export const portalSpendCategories = [
  'membership',
  'events',
  'training',
  'sponsorship',
  'other',
] as const
export type PortalSpendCategory = (typeof portalSpendCategories)[number]
export interface PortalMoney {
  cents: number
  formatted: string
}
export interface PortalSpendRow {
  invoice_id: number
  number: string
  issued_on: string
  billed_to_kind: 'organization' | 'person'
  billed_to: string | null
  person_status: 'current' | 'former' | 'erased' | null
  category: PortalSpendCategory
  net: PortalMoney
  // Net plus VAT on the invoice. Organization audience only shows its own invoices.
  gross_amount: PortalMoney
  // The person who placed the order (for example a training purchase billed to the organization).
  purchased_by: string | null
  status: 'paid' | 'unpaid'
  openable: boolean
}
export interface PortalSpendResponse {
  spend: {
    rows: PortalSpendRow[]
    total: number
    available_total: number
    net: PortalMoney
    categories: Array<{ key: PortalSpendCategory; label: string; amount: PortalMoney }>
    stats: { organization: PortalMoney; people: PortalMoney; unpaid: PortalMoney }
    pagination: { caption: string; next_cursor: string | null; previous_cursor: string | null }
  }
}
